// src/Component/Application/Identification/IdentificationList.tsx

import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { Btn } from '../../../AbstractElements';
import IdentificationService from '../../../Service/IdentificationService';
import { Identification } from './types';

interface Props {
  onAdd: () => void;
  onEdit: (item: Identification) => void;
  refresh: boolean;
}

const IdentificationList: React.FC<Props> = ({ onAdd, onEdit, refresh }) => {
  const [data, setData] = useState<Identification[]>([]);

  const fetchData = async () => {
    try {
      const response = await IdentificationService.getAll();
      setData(response.results); // ✅ Backend response contains { results: [...] }
    } catch (err) {
      console.error('Failed to fetch identifications:', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [refresh]);

  const columns = [
    {
      name: 'Name',
      selector: (row: Identification) => row.name,
      sortable: true,
    },
    {
      name: 'Length',
      selector: (row: Identification) => row.length,
      sortable: true,
    },
    {
      name: 'Required Country',
      selector: (row: Identification) => (row.requires_country ? 'Yes' : 'No'),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row: Identification) => (
        <>
          <Btn
            color="info"
            size="sm"
            onClick={() => onEdit(row)}
            className="me-2"
          >
            Edit
          </Btn>
          <Btn
            color="danger"
            size="sm"
            onClick={async () => {
              await IdentificationService.delete(row.id);
              fetchData(); // re-fetch after deletion
            }}
          >
            Delete
          </Btn>
        </>
      ),
    },
  ];

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-end mb-3">
          <Btn color="primary" onClick={onAdd}>
            Add Identification
          </Btn>
        </div>
        <DataTable
          columns={columns}
          data={data}
          pagination
          highlightOnHover
          striped
        />
      </CardBody>
    </Card>
  );
};

export default IdentificationList;
